import { gql } from "@apollo/client";

export const CREATE_VEHICLE_CHECKLIST = gql`
  mutation createVehicleCheckList($vehicleCheckList: VehicleCheckListInput!) {
    createVehicleCheckList(vehicleCheckList: $vehicleCheckList) {
      id
      generalCheckListItems {
        name
        isMandatory
      }
      accessoriesCheckListItems {
        name
        isMandatory
      }
      frogDiagram
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;